// src/components/Sidebar/SidebarProjectItem.jsx
import React, { memo, useMemo } from "react";
import TooltipPortal from "../TooltipPortal/TooltipPortal";
import sidebarOnHold from "../../assets/sidebar_onhold.png";
import sidebarCancel from "../../assets/sidebar_cancel.png";
import sidebarWaiting from "../../assets/sidebar_waiting.png";
import { truncate } from "./useProjectStatusMap";

const FLAG_ICON = {
  aborted: sidebarCancel,
  onhold: sidebarOnHold,
  waiting: sidebarWaiting,
};

const STATUS_BADGE = {
  aborted: { src: sidebarCancel, alt: "Aborted", className: "Sidebar-aborted-img" },
  onHold: { src: sidebarOnHold, alt: "On Hold", className: "Sidebar-on-hold-img" },
  waiting: { src: sidebarWaiting, alt: "Waiting", className: "Sidebar-waiting-img" },
};

function flagImgFor(flag) {
  if (!flag) return null;
  const f = flag.toLowerCase();
  if (f === "aborted") return FLAG_ICON.aborted;
  if (f === "onhold" || f === "on hold") return FLAG_ICON.onhold;
  if (f === "waiting") return FLAG_ICON.waiting;
  return null;
}

function ProjectStatusTooltip({ status }) {
  return (
    <div className="Sidebar-status-tooltip" role="tooltip">
      {(status.items || []).slice(0, 3).map((t, i) => (
        <div key={`${t.type}-${t.title}-${i}`} className="Sidebar-tooltip-task-row">
          {flagImgFor(t.flag) && (
            <img src={flagImgFor(t.flag)} alt="" className="Sidebar-tooltip-flag-icon" />
          )}
          <span>{truncate(t.title, 10)}</span>
        </div>
      ))}
    </div>
  );
}

function SidebarProjectItem({ project, active, status, collapsed, onSelect, style }) {
  const tooltipNode = useMemo(
    () => (status ? <ProjectStatusTooltip status={status} /> : null),
    [status],
  );
  const badge = status ? STATUS_BADGE[status.type] : null;

  return (
    <button
      type="button"
      className={`Sidebar-subitem ${active ? "active" : ""}`}
      style={style}
      onClick={() => onSelect(project.projectId)}
      role="option"
      aria-selected={active}
    >
      <TooltipPortal label={project.projectTitle} offsetY={28} offsetX={0}>
        <span className="Sidebar-text">
          {!collapsed
            ? project.projectTitle
            : (project.projectTitle || "?").charAt(0).toUpperCase()}
        </span>
      </TooltipPortal>

      {badge && (
        <TooltipPortal label={tooltipNode} offsetY={36} offsetX={30}>
          <img
            src={badge.src}
            alt={badge.alt}
            className={`Sidebar-status-badge ${badge.className}`}
          />
        </TooltipPortal>
      )}
    </button>
  );
}

function areEqual(prev, next) {
  return (
    prev.project === next.project &&
    prev.active === next.active &&
    prev.status === next.status &&
    prev.collapsed === next.collapsed &&
    prev.style?.transform === next.style?.transform
  );
}

export default memo(SidebarProjectItem, areEqual);
